<template>
  <div>
    <popup v-if="showPopup" @close="handleClose">
      <div slot="popupMainContent" class="justify-content-center text-left">
        <!--allow langauge switch-->
        <h2>
          <icon class="mr-1" type="robot"/>
          Important Notice | Wichtiger Hinweis
        </h2>
        <div class="d-flex justify-content-start mb-2">
          <select v-model="selectedLanguage" class="custom-select">
            <option v-for="lang in languages" :key="lang" :value="lang">
              {{ lang.toUpperCase() }}
            </option>
          </select>
        </div>
        <div class="important-msg form-error p-3 mb-2 margin-auto">
          <div v-if="selectedLanguage === 'en'">
            <h2>⚠ Scheduled System Maintenance – February 6th, 2026</h2>

            <p>
              As part of the ongoing development of our platform, a system maintenance will
              be carried out on <strong>February 6th, 2026</strong>.
            </p>
            <br />
            <b class="mt-2">Planned Limitations</b>

            <p><strong>From 9:00 AM:</strong></p>
            <ul>
              <li>vHUB 3D Data Import: Not available (all day)</li>
            </ul>

            <p><strong>From 7:00 PM – approx. 11:00 PM:</strong></p>
            <ul>
              <li>vHUB Platform: Not available</li>
              <li>
                vHUB Web Apps (Web Projects):
                <ul>
                  <li>Private apps not available</li>
                  <li>Published apps still accessible</li>
                </ul>
              </li>
              <li>
                vStage:
                <ul>
                  <li>Online mode not available</li>
                  <li>Offline mode limited</li>
                </ul>
              </li>
            </ul>

            <b>New Features</b>
            <ul>
              <li>
                vFORMS projects will now support all UTF-8 characters
                (including special characters, emojis, and characters from additional languages)
              </li>
              <li>New languages in vFORMS: Arabic, Chinese, Hindi</li>
            </ul>
          </div>
          <div v-else>
            <h2>⚠ Geplante Systemwartung – 06.02.2026</h2>

            <p>
              Im Rahmen der Weiterentwicklung unserer Plattform wird am
              <strong>06.02.2026</strong> eine Systemwartung durchgeführt.
            </p>
            <br/>
            <b>Geplante Einschränkungen</b>

            <p><strong>Ab 09:00 Uhr:</strong></p>
            <ul>
              <li>vHUB 3D-Daten Import: Nicht verfügbar (ganztägig)</li>
            </ul>

            <p><strong>Ab 19:00 Uhr – ca. 23:00 Uhr:</strong></p>
            <ul>
              <li>vHUB Plattform: Nicht verfügbar</li>
              <li>
                vHUB Web Apps (Web Projekte):
                <ul>
                  <li>Private Apps nicht verfügbar</li>
                  <li>Published Apps weiterhin zugänglich</li>
                </ul>
              </li>
              <li>
                vStage:
                <ul>
                  <li>Online-Modus nicht verfügbar</li>
                  <li>Offline-Modus eingeschränkt</li>
                </ul>
              </li>
            </ul>

            <b>Neuerungen</b>
            <ul>
              <li>
                vFORMS-Projekte unterstützen künftig alle UTF-8 Zeichen
                (inkl. Sonderzeichen, Emojis, Schriftzeichen weiterer Sprachen)
              </li>
              <li>Neue Sprachen in vFORMS: Arabisch, Chinesisch, Hindi</li>
            </ul>
          </div>
        </div>
        <!--add a checkbox: don't show this message again which then will hide the popup, using keepPopupHidden-->
        <checkbox-widget
            class="mt-3 ml-0"
            :initial-value="keepPopupHidden"
            :label-for="'chkHideImportantNoticePopup'"
            :label-text="selectedLanguage === 'en' ? 'Do not show this message again' : 'Diese Nachricht nicht mehr anzeigen'"
            @change="(val) => { keepPopupHidden = val; }"
        />
        <div @click="handleClose" class="settings-button d-inline-block switched-colors">{{ $t('close') }}</div>
      </div>
    </popup>
  </div>
</template>

<script>
import Popup from "@/components/Popup.vue";
import Icon from "@/components/Icon.vue";
import CheckboxWidget from "@/components/widgets/editors/Checkbox.vue";
export default {
  name: "ImportantNoticePopup",
  components: {
    Popup,
    Icon,
    CheckboxWidget
  },
  data() {
    return {
      showPopup: false,
      popupKey: 'popup-6',
      languages: ['en', 'de'],
      selectedLanguage: "en",
      keepPopupHidden: false
    };
  },
  created() {
    this.checkPopupStatus();
  },
  methods: {
    checkPopupStatus() {
      const hasSeenPopup = localStorage.getItem(this.popupKey);
      if (!hasSeenPopup) {
        this.showPopup = true;
      }
    },
    hidePopupForever() {
      localStorage.setItem(this.popupKey, "true");
    },
    handleClose() {
      this.showPopup = false;
      if(this.keepPopupHidden) {
        this.hidePopupForever();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.important-msg {
  min-width: 400px;
  max-width: 100%;
}

.custom-select {
  background-color: var(--vform-editor-ui-quinary-color);
  color: #fff;
  max-width: 100px;
}
</style>

